export default "__VITE_ASSET__WR0VnJ16__"